
// Slick carousel (used on testimonials) http://kenwheeler.github.io/slick/
//import jquery from 'jquery'

import 'slick-carousel';

// window.jQuery = window.$ = $;

// Slick (Slider) http://kenwheeler.github.io/slick/
// Better include this before basicscroll
(function($) { "use strict";

	//
	// Hero Slider
	//
	var $slider = $('.js-hero-slider');
	
	// check page contains element
	if( $slider.length ) {
		
		
		// On first initialization
		$slider.on('init', function(slick) {
			
			let firstItem = $('.section-hero-slider .slick-dots li:first-child');
			
			// To trigger the first item's transition on page load
			firstItem.removeClass('slick-active');
			
			setTimeout(function() {
				firstItem.addClass('slick-active');
			}, 1);

			const slide_count = $slider.find('.hero-slide').length;
		});
		


		// On before slide change
		$slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
			
			$('body').addClass('js-hero-active'); //Used to adjust animation-duration in CSS after the first slide is cycled.		

			const slide_kind = $('.hero-slide', slick.$slides[nextSlide]).data('slide-kind');

		});


		
		// initialize and configure.
		$slider.slick({
			fade: true,
			dots: false,
			arrows: false,
			pauseOnFocus: false,
			pauseOnHover: false,
			draggable: false,
			touchMove: false,
			swipeToSlide: false,
			swipe: false,
			autoplay: true,
			infinite: true,
			autoplaySpeed: 5000, // TODO SET BACK TO 5sec
			speed: 2000
		});
		
		
	}

	

	// //
	// // Full width
	// //
	// // check page contains element
	// if( $('.block-header-carousel').length ) {


	// 	$('.block-header-carousel').slick({
	// 				dots: true,
	// 				arrows: true,
	// 				slidesToShow: 1,
	// 				slidesToScroll: 1,
	// 				// centerMode: true,
	// 				// variableWidth: true,
	// 				// pauseOnHover: false,
	// 				autoplay: false,
	// 				touchThreshold: 30,
	// 				speed: 1000,
	// 				responsive: [
	// 					{
	// 						breakpoint: 1000,
	// 						settings: {
	// 							centerMode: true,
	// 							centerPadding: '40px',
	// 							slidesToShow: 2
	// 						}
	// 					},
	// 					{
	// 						breakpoint: 750,
	// 						settings: {
	// 							centerMode: true,
	// 							centerPadding: '100px',
	// 							slidesToShow: 1
	// 						}
	// 					},
	// 					{
	// 						breakpoint: 650,
	// 						settings: {
	// 							centerMode: true,
	// 							centerPadding: '0px',
	// 							slidesToShow: 1
	// 						}
	// 					}
	// 				]
	// 	});
	// }












		
	
		
		

})(jQuery);
